module.exports = __webpack_public_path__ + "img/0.927633f0.png";